import React, { useEffect, useState } from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header';
import { mobileStyles, styles } from '../../styles/affiliateStyles';
import userServiceInstance from '../../services/userService';
import { useNotification } from '../../context/notificationContext';
import Loader from '../../components/Loader/Loader';
import { useAuth } from '../../context/userContext';
import moment from "moment";
import "../../styles/profile.scss"
import CustomModal from '../../components/CustomModal';
import CustomInput from '../../components/reusable/CustomInput';
import CustomButton from '../../components/reusable/CustomButton';
import ButtonLoader from '../../components/reusable/ButtonLoader';

const AffiliateDashboard = () => {
    const [, , showNotification] = useNotification();
    const { auth, refetchProfile } = useAuth()
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [orderData, setOrderData] = useState({});
    const [transactionData, setTransactionData] = useState([]);
    const [copied, setCopied] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [transactionCurrentPage, setTransactionCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const handleCopyCouponCode = () => {
        navigator.clipboard.writeText(auth?.user?.coupon?.code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const totalPages = Math.ceil(orderData?.length / itemsPerPage);
    const totalTransactionPages = Math.ceil(orderData?.length / itemsPerPage);


    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedOrders = orderData?.length > 0 && orderData?.slice(startIndex, startIndex + itemsPerPage);

    const startIndexTransaction = (transactionCurrentPage - 1) * itemsPerPage;
    const paginatedOrdersTransaction = transactionData?.transaction?.length > 0 && transactionData?.transaction?.slice(startIndexTransaction, startIndexTransaction + itemsPerPage);

    const fetchAffiliateStats = async () => {
        setLoading(true);
        try {
            const res = await userServiceInstance.getWalletDetails();
            setLoading(false);
            if (res?.data?.success) {
                setData(res?.data?.wallet);
            } else {
                showNotification("error", res?.data?.message)

            }
        } catch (error) {
            setLoading(false);
            showNotification("error", error?.response?.data?.message)
        }
    }


    const fetchOrderList = async () => {
        setLoading(true);
        try {
            const res = await userServiceInstance.getOrderDetails(5, currentPage);
            setLoading(false);
            // console.log(res);

            if (res?.data?.success) {
                setOrderData(res?.data?.orders);
            } else {
                showNotification("error", res?.data?.message)

            }
        } catch (error) {
            setLoading(false);
            showNotification("error", error?.response?.data?.message)
        }
    }

    const fetchTransactionList = async () => {
        setLoading(true);
        try {
            const res = await userServiceInstance.getAllPyaoutTransaction(5, transactionCurrentPage);
            setLoading(false);
            if (res?.data?.success) {
                setTransactionData(res?.data);

            } else {
                showNotification("error", res?.data?.message)

            }
        } catch (error) {
            setLoading(false);
            showNotification("error", error?.response?.data?.message)
        }
    }


    useEffect(() => {
        fetchAffiliateStats();
        fetchTransactionList();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        fetchOrderList(5, currentPage);
    }, [currentPage])

    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [accountLoading, setAccountLoading] = useState(false);
    const [bankValidation, setBankValidation] = useState(false)
    const [accountDetails, setAccountDetails] = useState({
        amount: "",
        accountNumber: "",
        accountHolderName: "",
        ifscCode: "",
        bankName: "",
        upiId: "",
        branchName: ""
    });

    useEffect(() => {
        if (auth?.user?.bank) {
            setAccountDetails({
                accountNumber: auth?.user?.bank?.accountNumber,
                accountHolderName: auth?.user?.bank?.accountHolderName,
                ifscCode: auth?.user?.bank?.ifscCode,
                bankName: auth?.user?.bank?.bankName,
                upiId: auth?.user?.bank?.upiId ? auth?.user?.bank?.upiId : "",
                branchName: auth?.user?.bank?.branchName
            })
        }
    }, [auth?.user?.bank])


    const { amount, accountNumber, accountHolderName, bankName, branchName, ifscCode } = accountDetails

    const handlePayoutRequest = async () => {

        if (amount === "" || !amount) {
            showNotification("warning", "Please enter amount for withdraw");
            return;
        }

        if (amount > (data?.totalEarned - data?.totalWithdrawn - data?.requestedPayout)) {
            showNotification("warning", "You do not have sufficient funds to withdraw");
            return;
        }

        if (!auth?.user?.bank && !bankValidation) {
            setBankValidation(true);
            setShowAccountModal(true);
            return;
        }

        setAccountLoading(true);

        try {
            const res = await userServiceInstance.payoutRequest(amount)
            if (res?.data?.success) {
                showNotification("success", res?.data?.message);
                fetchAffiliateStats();
                fetchOrderList();
                refetchProfile();
            } else {
                showNotification("warning", res?.data?.message)
            }
            setAccountLoading(false);

        } catch (error) {
            showNotification("warning", error?.response?.data?.message);

            setAccountLoading(false);

        }
    }

    // SAVE BANK DETAILS STARTS 

    const handleSaveBankDetails = async () => {

        if (accountNumber === "" || accountHolderName === "" || bankName === "" || branchName === "" || ifscCode === "") {
            showNotification("warning", "Please fill all details");
            return;
        }

        setAccountLoading(true);

        try {
            const res = await userServiceInstance.addBankDetails(accountDetails)
            if (res?.data?.success) {
                showNotification("success", res?.data?.message);
                setAccountLoading(false);
                setShowAccountModal(false);
                if (bankValidation) {
                    handlePayoutRequest()
                }
            } else {
                showNotification("warning", res?.data?.message)
                setAccountLoading(false);

            }

        } catch (error) {
            showNotification("warning", error?.response?.data?.message);
            setAccountLoading(false);

        }
    }
    // SAVE BANK DETAILS ENDS 

    return (
        loading ? <Loader /> :
            <>
                <Header />
                <style>{mobileStyles}</style>
                <div className='container'>
                    <div style={styles.container} className="dashboard-container">
                        <div style={styles.header}>
                            <h1 style={styles.title} className='dashboard_title'>
                                🏆 Affiliate Dashboard
                            </h1>
                            <p style={styles.subtitle}>Track your performance and earnings</p>
                        </div>
                        <div style={styles.couponCodeDisplay} className="coupon-code-display">
                            <div style={styles.couponCodeTxt}>
                                <div style={{ fontSize: '14px', marginBottom: '8px' }}>Your Affiliate Coupon Code</div>
                                <div style={styles.couponCode} className="coupon-code">{auth?.user?.coupon?.code}</div>
                                <button
                                    style={{
                                        ...styles.copyButton,
                                        backgroundColor: copied ? '#124b04' : 'rgb(251, 121, 116)'
                                    }}
                                    onClick={handleCopyCouponCode}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#124b04'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = copied ? '#124b04' : 'rgb(251, 121, 116)'}
                                >
                                    📋 {copied ? 'Copied!' : 'Copy Code'}
                                </button>
                            </div>
                            <div className='payout'>
                                <p>
                                    Withdraw your earned affiliate rewards easily and securely
                                </p>
                                <div className='form'>
                                    <input label="Enter Payout Amount"
                                        placeholder="Ex:- 5000"
                                        value={accountDetails.amount}
                                        onChange={(e) =>
                                            setAccountDetails({ ...accountDetails, amount: e.target.value })
                                        }
                                    />
                                    <button
                                        className='btn'
                                        onClick={() => handlePayoutRequest()}
                                    >
                                        Withdraw Request
                                    </button>
                                </div>

                            </div>
                        </div>

                        {
                            auth?.user?.bank &&
                            <div className="bankDetailsDisplay">
                                <h3>Your Bank Details</h3>
                                <ul>
                                    <li>
                                        <strong>Account Number:</strong> {auth?.user?.bank?.accountNumber}
                                    </li>
                                    <li>
                                        <strong>Account Holder Name:</strong>{' '}
                                        {auth?.user?.bank?.accountHolderName}
                                    </li>
                                    <li>
                                        <strong>IFSC Code:</strong> {auth?.user?.bank?.ifscCode}
                                    </li>
                                    <li>
                                        <strong>Bank Name:</strong> {auth?.user?.bank?.bankName}
                                    </li>
                                    <li>
                                        <strong>Branch Name:</strong> {auth?.user?.bank?.branchName}
                                    </li>
                                    {auth?.user?.bank?.upiId && (
                                        <li>
                                            <strong>UPI ID:</strong> {auth?.user?.bank?.upiId}
                                        </li>
                                    )}
                                </ul>
                                <button className="editBankBtn" onClick={() => setShowAccountModal(true)}>
                                    ✏️ Edit Bank Details
                                </button>
                            </div>
                        }


                        {/* Stats Cards */}
                        <div style={styles.grid} className="card-grid">
                            <div style={styles.card}>
                                <div style={styles.cardIcon}>💳</div>
                                <div style={styles.cardTitle}>Wallet Balance</div>
                                <div style={{ ...styles.cardValue, ...styles.highlightValue }}>
                                    Rs.{(data?.totalEarned - data?.totalWithdrawn - data?.requestedPayout) ? Math.round((data?.totalEarned - data?.totalWithdrawn - data?.requestedPayout)) : 0}
                                </div>
                            </div>

                            <div style={styles.card}>
                                <div style={styles.cardIcon}>🛒</div>
                                <div style={styles.cardTitle}>Total Sales</div>
                                <div style={styles.cardValue}>
                                    Rs.{data?.totalSales ? Math.round(data?.totalSales?.toFixed(2)) : 0}
                                </div>
                            </div>

                            <div style={styles.card}>
                                <div style={styles.cardIcon}>📊</div>
                                <div style={styles.cardTitle}>Reward Rate</div>
                                <div style={{ ...styles.cardValue, ...styles.highlightValue }}>
                                    {auth?.user?.coupon?.affiliatePercent}%
                                </div>
                            </div>

                            {/* <div style={styles.card}>
                                <div style={styles.cardIcon}>🎁</div>
                                <div style={styles.cardTitle}>Total Discounts Given</div>
                                <div style={styles.cardValue}>
                                    Rs.{data?.discount?.toFixed(2)}
                                </div>
                            </div> */}
                        </div>

                        {/* Performance Overview */}
                        <div style={styles.performanceGrid} className="performance-grid">
                            <div style={styles.performanceCard}>
                                <div style={styles.cardTitle}>This Month's Performance</div>
                                <div style={{ ...styles.cardValue, color: 'white', fontSize: '32px' }}>
                                    {
                                        ((auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100)
                                            ? ((auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100)?.toFixed(0) + "%"
                                            : "0%"
                                    }
                                </div>
                                <div style={styles.progressBar}>
                                    <div style={{
                                        ...styles.progressFill,
                                        width: ((auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100
                                        ) + "%",
                                        background: (auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100 > 75 ? "green" : "#c5c5c5",
                                        border: (auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100 > 75 ? "1px solid green" : "1px solid #c5c5c5",

                                    }}></div>
                                </div>
                                <div style={{
                                    fontSize: '12px', opacity: 0.8
                                }}>
                                    {
                                        (auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100 > 75 ?
                                            "Great performance this month!" : "Need to improve"
                                    }
                                </div>
                            </div>

                            <div style={styles.card}>
                                <div style={styles.cardIcon}>🎯</div>
                                <div style={styles.cardTitle}>Conversion Rate</div>
                                <div style={{ ...styles.cardValue, ...styles.highlightValue }}>
                                    {((auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100) ? ((auth?.user?.coupon?.usedCount / auth?.user?.coupon?.validateCount) * 100)?.toFixed(0) : 0} %
                                </div>
                                <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #f0f0f0' }} />
                                <div style={{ fontSize: '12px', color: '#666' }}>{auth?.user?.coupon?.usedCount} orders / {auth?.user?.coupon?.validateCount} views</div>
                            </div>
                        </div>

                        {/* Orders Table */}
                        <div style={styles.tableCard}>
                            <div style={styles.tableHeader}>
                                <h3 style={{ margin: 0 }}>Recent Orders</h3>
                                <span style={{
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '12px'
                                }}>
                                    {orderData?.length} Total Orders
                                </span>
                            </div>

                            <div className="table-wrapper">
                                <table style={styles.table} className="table-responsive">
                                    <thead>
                                        <tr>
                                            <th style={styles.th}>Order ID</th>
                                            <th style={styles.th}>Order Value</th>
                                            <th style={styles.th}>Order Type</th>
                                            {/* <th style={styles.th}>Discount</th> */}
                                            <th style={styles.th}>Reward Amount</th>
                                            <th style={styles.th}>Date</th>
                                            <th style={styles.th}>Payment Status</th>
                                            <th style={styles.th}>Order Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedOrders && paginatedOrders?.map((order, index) => {
                                            const orderAmt = order?.totalPrice
                                            const affiliatePercent = order?.couponCode?.affiliatePercent
                                            const yourReward = orderAmt * affiliatePercent / 100
                                            return (
                                                <tr
                                                    key={index}
                                                    style={styles.tr}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(18, 75, 4, 0.05)'}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    <td style={styles.td}>
                                                        <strong>{order?.orderId}</strong>
                                                    </td>

                                                    <td style={styles.td}>
                                                        <strong>Rs.{Math.round(order?.totalPrice?.toFixed(2))}</strong>
                                                    </td>
                                                    <td style={styles.td}>
                                                        <strong>{order?.paymentMethod}</strong>
                                                    </td>
                                                    {/* <td style={styles.td}>
                                                        <span style={{ ...styles.tag, ...styles.discountTag }}>
                                                            Rs.{order?.discount?.toFixed(2)}
                                                        </span>
                                                    </td> */}
                                                    <td style={styles.td}>
                                                        <span style={{ ...styles.tag, ...styles.discountTag }}>
                                                            Rs.{order.status === 'cancelled' ? 0 : yourReward?.toFixed(2)}
                                                        </span>
                                                    </td>
                                                    <td style={styles.td}>{moment(order?.updatedAt).format("DD-MM-yyyy")}</td>
                                                    <td style={styles.td}>
                                                        <span style={order.paymentStatus === 'Pending' ? styles.statusPending : order.status === 'cancelled' ? styles.statusCancelled : styles.statusCompleted}>
                                                            ● {order?.paymentStatus !== null ? order?.paymentStatus : "Refunded"}
                                                        </span>
                                                    </td>

                                                    <td style={styles.td}>
                                                        <span style={order.status === 'Processing' ? styles.statusPending : order.status === 'cancelled' ? styles.statusCancelled : styles.statusCompleted}>
                                                            ● {order?.status?.charAt(0).toUpperCase() + order?.status?.slice(1)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div style={styles.pagination}>
                                <button
                                    style={{
                                        ...styles.pageButton,
                                        opacity: currentPage === 1 ? 0.5 : 1,
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    ← Previous
                                </button>

                                {totalPages > 0 && [...Array(totalPages)]?.map((_, index) => (
                                    <button
                                        key={index}
                                        style={{
                                            ...styles.pageButton,
                                            ...(currentPage === index + 1 ? styles.activePageButton : {})
                                        }}
                                        onClick={() => setCurrentPage(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                ))}

                                <button
                                    style={{
                                        ...styles.pageButton,
                                        opacity: currentPage === totalPages ? 0.5 : 1,
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    disabled={currentPage === totalPages || totalPages?.length > 0}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Next →
                                </button>
                            </div>
                        </div>

                        {/* TRANSACTION HISTORY TABLE  */}

                        {
                            transactionData?.transaction?.length > 0 &&

                            <div style={styles.tableCard}>
                                <div style={styles.tableHeader}>
                                    <h3 style={{ margin: 0 }}>Recent Payouts</h3>
                                    <span style={{
                                        backgroundColor: 'rgba(255,255,255,0.2)',
                                        padding: '4px 12px',
                                        borderRadius: '12px',
                                        fontSize: '12px'
                                    }}>
                                        {transactionData?.transaction?.length} Total Payouts
                                    </span>
                                </div>

                                <div className="table-wrapper">
                                    <table style={styles.table} className="table-responsive">
                                        <thead>
                                            <tr>
                                                <th style={styles.th}>Payout Image</th>
                                                <th style={styles.th}>Payout Amount</th>
                                                <th style={styles.th}>Approved Amount</th>
                                                <th style={styles.th}>Transfer Type</th>
                                                <th style={styles.th}>Note</th>
                                                <th style={styles.th}>Requested Date & Time</th>
                                                <th style={styles.th}>Approved Date & Time</th>
                                                <th style={styles.th}>Payout Status</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedOrdersTransaction && paginatedOrdersTransaction?.map((order, index) => {

                                                return (
                                                    <tr
                                                        key={index}
                                                        style={styles.tr}
                                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(18, 75, 4, 0.05)'}
                                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                    >
                                                        <td style={styles.td}>
                                                            <img onClick={() => {
                                                                setPreviewImage(process.env.REACT_APP_FILE_PATH + "/" + order.screenshot);
                                                                setPreviewVisible(true);
                                                            }} style={styles.image} src={process.env.REACT_APP_FILE_PATH + "/" + order.screenshot} alt={order.screenshot} />
                                                        </td>
                                                        <td style={styles.td}>
                                                            <strong>{order?.requestedPayout}</strong>
                                                        </td>
                                                        <td style={styles.td}>
                                                            <strong>{order?.approvedPayout}</strong>
                                                        </td>
                                                        <td style={styles.td}>
                                                            <strong>{order?.paymentMethod}</strong>
                                                        </td>
                                                        <td style={styles.td}>
                                                            <strong>{order?.note}</strong>
                                                        </td>

                                                        <td style={styles.td}>{moment(order?.updatedAt).format("DD-MM-yyyy")}</td>
                                                        <td style={styles.td}>{moment(order?.updatedAt).format("DD-MM-yyyy")}</td>

                                                        <td style={styles.td}>
                                                            <span style={order.paymentStatus === 'Pending' ? styles.statusPending : order.status === 'cancelled' ? styles.statusCancelled : styles.statusCompleted}>
                                                                ● {order?.status?.toUpperCase()}
                                                            </span>
                                                        </td>

                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                <div style={styles.pagination}>
                                    <button
                                        style={{
                                            ...styles.pageButton,
                                            opacity: transactionCurrentPage === 1 ? 0.5 : 1,
                                            cursor: transactionCurrentPage === 1 ? 'not-allowed' : 'pointer'
                                        }}
                                        disabled={transactionCurrentPage === 1}
                                        onClick={() => setTransactionCurrentPage(transactionCurrentPage - 1)}
                                    >
                                        ← Previous
                                    </button>

                                    {totalTransactionPages > 0 && [...Array(totalTransactionPages)]?.map((_, index) => (
                                        <button
                                            key={index}
                                            style={{
                                                ...styles.pageButton,
                                                ...(transactionCurrentPage === index + 1 ? styles.activePageButton : {})
                                            }}
                                            onClick={() => setTransactionCurrentPage(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}

                                    <button
                                        style={{
                                            ...styles.pageButton,
                                            opacity: transactionCurrentPage === totalTransactionPages ? 0.5 : 1,
                                            cursor: transactionCurrentPage === totalTransactionPages ? 'not-allowed' : 'pointer'
                                        }}
                                        disabled={transactionCurrentPage === totalTransactionPages || totalTransactionPages?.length > 0}
                                        onClick={() => setTransactionCurrentPage(transactionCurrentPage + 1)}
                                    >
                                        Next →
                                    </button>
                                </div>
                            </div>

                        }


                        {/* Summary Footer */}
                        <div style={styles.summaryCard}>
                            <div style={styles.summaryGrid} className="summary-grid">
                                <div>
                                    <div style={styles.cardIcon}>💰</div>
                                    <div style={styles.cardTitle}>Total Earned</div>
                                    <div style={styles.cardValue}>Rs.{data?.totalEarned ? data?.totalEarned?.toFixed(2) : 0}</div>
                                </div>

                                <div>
                                    <div style={styles.cardIcon}>⏳</div>
                                    <div style={styles.cardTitle}>Pending Rewards</div>
                                    <div style={{ ...styles.cardValue, ...styles.highlightValue }}>Rs.{data?.pendingRewards ? data?.pendingRewards?.toFixed(2) : 0}</div>
                                </div>

                                <div>
                                    <div style={styles.cardIcon}>⏳</div>
                                    <div style={styles.cardTitle}>Pending Payout</div>
                                    <div style={{ ...styles.cardValue, ...styles.highlightValue }}>Rs.{data?.requestedPayout ? data?.requestedPayout?.toFixed(2) : 0}</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div >
                <Footer />

                {/* WITHDRAW MODAL STARTS  */}
                <CustomModal show={showAccountModal} setShow={setShowAccountModal}>
                    <>
                        <h3
                        >
                            Add / Verify Account Details
                        </h3>

                        <div className="form">

                            <CustomInput
                                label="Account Number"
                                placeholder="Enter your account number"
                                value={accountDetails.accountNumber}
                                type="number"
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, accountNumber: e.target.value })
                                }
                            />
                            <CustomInput
                                label="Account Holder Name"
                                placeholder="Enter account holder's name"
                                value={accountDetails.accountHolderName}
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, accountHolderName: e.target.value })
                                }
                            />

                            <CustomInput
                                label="IFSC Code"
                                placeholder="Enter IFSC code"
                                value={accountDetails.ifscCode.toUpperCase()}
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, ifscCode: e.target.value })
                                }
                            />

                            <CustomInput
                                label="Bank Name"
                                placeholder="Enter Bank Name"
                                name="bankName"
                                value={accountDetails.bankName}
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, bankName: e.target.value })
                                }
                            />

                            <CustomInput
                                label="UPI ID (optional)"
                                placeholder="Enter UPI ID (if any)"
                                value={accountDetails.upiId}
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, upiId: e.target.value })
                                }
                            />

                            <CustomInput
                                label="Branch Name"
                                placeholder="Enter Branch Name"
                                value={accountDetails.branchName}
                                onChange={(e) =>
                                    setAccountDetails({ ...accountDetails, branchName: e.target.value })
                                }
                            />

                        </div>

                        <p
                            style={{
                                display: 'flex',
                                columnGap: '4px',
                                textAlign: "left",
                                marginBottom: "15px",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: 1.4,
                                fontFamily: "sans-serif",
                                color: "#333",
                                textTransform: "capitalize",
                            }}
                        >
                            <span>
                                Note:
                            </span>
                            <span>
                                Kindly double-check your bank details before submitting. In case incorrect details are provided, the payment will be processed accordingly and may not be recoverable
                            </span>
                        </p>
                        <div className="update_btn">
                            <CustomButton
                                onClick={handleSaveBankDetails}
                                width="190px"
                                className="login_btn"
                                title={accountLoading ? <ButtonLoader /> : !bankValidation ? "Save Details" : "Send Payout Request"}
                            />
                        </div>
                    </>
                </CustomModal>
                {/* WITHDRAW MODAL ENDS */}


                {/* IMAGE PREVIEW MODAL  */}

                <CustomModal
                    show={previewVisible} setShow={setPreviewVisible}
                >
                    <img
                        alt="preview"
                        style={{ width: "100%", height: "auto" }}
                        src={previewImage}
                    />
                </CustomModal>

            </>
    );
};

export default AffiliateDashboard;